module.exports = __webpack_public_path__ + "img/icon-arrow-down-black.bd7dbae8.svg";